module.exports = __webpack_public_path__ + "img/search.720f51a2.svg";